import { ReactElement, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useData } from '../context/data.context';
import { TIMEZONES_WITH_DETAIL } from '../constants/global-constants';

type TimeZoneAttr = {
  name: string;
  abbr: string;
  time: string;
};

/**
 * A Sensors component that returns selected timezone.
 * @returns Diffrent type of sensor.
 */
export default function Timezone(): ReactElement {
  const { userConfigData, loading } = useData();
  const [timezone, setTimezone] = useState<TimeZoneAttr | null>(null);
  useEffect(() => {
    const clientTimeZone: string =
      userConfigData?.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (clientTimeZone) {
      setTimezone(TIMEZONES_WITH_DETAIL[clientTimeZone as any]);
    }
  }, [userConfigData]);

  if (loading && !timezone?.abbr) {
    return <div />;
  }
  return (
    <NavLink
      to="/settings/organization"
      className="flex justify-center items-center gap-3 border w-full border-gray-200 p-1 lg:p-2 rounded dark:border-gray-800 mr-0 lg:mr-3"
    >
      <div className="flex items-center text-sm text-gray-400 font-medium dark:text-gray-300">
        <span className="material-icons">language</span>
      </div>
      <div className="text-sm text-gray-200">{timezone?.abbr}</div>
    </NavLink>
  );
}
